var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    ref: "addTenantForm",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var invalid = ref.invalid
          return [
            _c(
              "b-form",
              {
                staticClass: "mx-1",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.addTenant($event)
                  },
                },
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Company Id (No spaces)",
                              "label-for": "login-id",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Company Id",
                                vid: "Company Id",
                                rules: "required|no_spaces",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "login-id",
                                            state:
                                              errors.length > 0 ? false : null,
                                            name: "login-name",
                                            placeholder: "Company Id",
                                          },
                                          model: {
                                            value: _vm.CompanyId,
                                            callback: function ($$v) {
                                              _vm.CompanyId = $$v
                                            },
                                            expression: "CompanyId",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Company Name",
                              "label-for": "login-name",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "name",
                                vid: "name",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "login-name",
                                            state:
                                              errors.length > 0 ? false : null,
                                            name: "login-name",
                                            placeholder: "Company Name",
                                          },
                                          model: {
                                            value: _vm.name,
                                            callback: function ($$v) {
                                              _vm.name = $$v
                                            },
                                            expression: "name",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Email",
                              "label-for": "login-email",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Email",
                                vid: "email",
                                rules: "required|email",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "login-email",
                                            state:
                                              errors.length > 0 ? false : null,
                                            name: "login-email",
                                            placeholder: "john@example.com",
                                          },
                                          model: {
                                            value: _vm.adminEmail,
                                            callback: function ($$v) {
                                              _vm.adminEmail = $$v
                                            },
                                            expression: "adminEmail",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-form-group",
                          _vm._l(_vm.modules, function (item) {
                            return _c(
                              "b-form-checkbox",
                              {
                                key: item.id,
                                staticClass: "my-1",
                                attrs: { id: item.id, name: item.name },
                                on: {
                                  change: function ($event) {
                                    return _vm.handleCheckboxChange(item)
                                  },
                                },
                                model: {
                                  value: item.isActive,
                                  callback: function ($$v) {
                                    _vm.$set(item, "isActive", $$v)
                                  },
                                  expression: "item.isActive",
                                },
                              },
                              [_vm._v(" " + _vm._s(item.name) + " ")]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "b-card",
                          { attrs: { title: "Upload your company logo" } },
                          [
                            _c(
                              "b-media",
                              { attrs: { "no-body": "" } },
                              [
                                _c(
                                  "b-media-aside",
                                  [
                                    _c(
                                      "b-link",
                                      [
                                        _vm.imageFile != null &&
                                        _vm.imageFile.length != 0
                                          ? _c("b-img", {
                                              ref: "previewEl",
                                              attrs: {
                                                rounded: "",
                                                src: _vm.imageFile,
                                                height: "80",
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-media-body",
                                  { staticClass: "mt-75 ml-75" },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "custom-file-upload text-white mb-75 mr-75",
                                        attrs: { for: "file-upload" },
                                      },
                                      [_vm._v(" Upload ")]
                                    ),
                                    _c("input", {
                                      attrs: {
                                        id: "file-upload",
                                        type: "file",
                                        accept: "image/jpg,image/jpeg",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.showImagePreview($event)
                                        },
                                      },
                                    }),
                                    _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "ripple",
                                            rawName: "v-ripple.400",
                                            value: "rgba(186, 191, 199, 0.15)",
                                            expression:
                                              "'rgba(186, 191, 199, 0.15)'",
                                            modifiers: { 400: true },
                                          },
                                        ],
                                        attrs: {
                                          variant: "outline-secondary",
                                          size: "sm",
                                        },
                                        on: { click: _vm.clearImage },
                                      },
                                      [_vm._v(" Reset ")]
                                    ),
                                    _c("b-card-text", { staticClass: "mx-3" }, [
                                      _vm._v("Allowed JPG. Max size of 800kB"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Company Address Line 1",
                              "label-for": "login-Address",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Address Line 1",
                                vid: "Address Line 1",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "login-Address",
                                            state:
                                              errors.length > 0 ? false : null,
                                            name: "addressLine1",
                                            placeholder: "Address Line 1",
                                          },
                                          model: {
                                            value: _vm.addressLine1,
                                            callback: function ($$v) {
                                              _vm.addressLine1 = $$v
                                            },
                                            expression: "addressLine1",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: { label: "City", "label-for": "login-City" },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "City",
                                vid: "City",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "login-City",
                                            state:
                                              errors.length > 0 ? false : null,
                                            name: "City",
                                            placeholder: "City",
                                          },
                                          model: {
                                            value: _vm.City,
                                            callback: function ($$v) {
                                              _vm.City = $$v
                                            },
                                            expression: "City",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Country",
                              "label-for": "login-Country",
                            },
                          },
                          [
                            _c("b-form-select", {
                              attrs: { options: _vm.country },
                              model: {
                                value: _vm.selected,
                                callback: function ($$v) {
                                  _vm.selected = $$v
                                },
                                expression: "selected",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "ripple",
                                rawName: "v-ripple.400",
                                value: "rgba(255, 255, 255, 0.15)",
                                expression: "'rgba(255, 255, 255, 0.15)'",
                                modifiers: { 400: true },
                              },
                            ],
                            staticClass: "mr-1",
                            attrs: {
                              type: "submit",
                              variant: "primary",
                              disabled: invalid,
                            },
                          },
                          [
                            _vm.loading
                              ? _c("b-spinner", { attrs: { small: "" } })
                              : _vm._e(),
                            _vm._v(" Submit "),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }